import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface LandscapingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Landscaping: React.FC<LandscapingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [landscaping, set_landscaping] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Landscaping'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Landscaping': v } } })
    );
    const label = 'Landscaping';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(landscaping)}
                />
            ) : (
                <MoneyBox
                    id={'landscaping'}
                    allowNegative={false}
                    value={landscaping ?? 0}
                    onChange={(value) => set_landscaping(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
